// extracted by mini-css-extract-plugin
module.exports = {"root":"RemainingTime_root__QIPWu","warning":"RemainingTime_warning__fos3d","danger":"RemainingTime_danger__KGabN"};